import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const usePrepareCart = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    const { cart, setCart, booking, consumer, selectedCapacity, selectedApptype, selectedResource, selectedCapacityGroups, getDaoAppointments, getDaoProducts } = useWidgetStore();
    const { hasResourceSelect } = useSettings();
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-prepareCart'], queryFn: async ({ signal }) => {
            var _a, _b, _c, _d;
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'prepareCart', 'checkout');
            let _consumer = {
                hash: (_a = consumer.hash) !== null && _a !== void 0 ? _a : '',
                id: (_b = consumer.id) !== null && _b !== void 0 ? _b : ''
            };
            // these are loaded using useVouchers in the summary
            let _discounts = cart.discounts;
            let _appointments = getDaoAppointments(), _products = getDaoProducts(), hasSelectedResource = selectedResource ? selectedResource.filter((resourceId) => resourceId !== -1).length > 0 : false;
            let data = {
                appointments: _appointments.length > 0 ? _appointments.map((_appointment) => {
                    var _a, _b, _c, _d;
                    return {
                        appTypeId: selectedApptype,
                        resourceId: hasSelectedResource ? selectedResource : null,
                        capacity: selectedCapacity,
                        components: [_appointment],
                        date: (_a = _appointment.date) !== null && _a !== void 0 ? _a : _appointment.time,
                        time: _appointment.time,
                        fields: (_b = consumer.fields) !== null && _b !== void 0 ? _b : {},
                        remark: (_c = booking.remark) !== null && _c !== void 0 ? _c : ((_d = consumer.remark) !== null && _d !== void 0 ? _d : '')
                    };
                }) : [],
                products: _products,
                discounts: _discounts,
                customer: _consumer,
                remark: (_c = consumer.remark) !== null && _c !== void 0 ? _c : ''
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            setCart(Object.assign(Object.assign({}, cart), { secureToken: (_d = response.headers.get('x-oanl-secure-token')) !== null && _d !== void 0 ? _d : '' }));
            return response.json();
        } }));
};
